import { WarningLocation, TranspilerWarning, EditorWarning } from 'frontend/types/lessons/warnings';

function formatCamperdownWarningLocation(location: WarningLocation): string {
  if (location.start.line - location.end.line > 0) {
    return `Lines ${location.start.line} - ${location.end.line}`;
  }
  if (location.start.column - location.end.column > 0) {
    return `Line ${location.start.line}, cols ${location.start.column}-${location.end.column}`;
  }
  return `Line ${location.start.line}, col ${location.start.column}`;
}

/** Prepend location info onto a transpiler warning message */
export function formatTranspilerWarning(warning: TranspilerWarning): string {
  if (warning.sourceType === 'camperdown') {
    return `${formatCamperdownWarningLocation(warning.location)}: ${warning.message}`;
  }
  return warning.message;
}

/** Determine if a warning should prevent publishing a lesson version */
export function shouldWarningBlockPublishing(warning: EditorWarning): boolean {
  return warning.severity === 'error' || warning.severity === 'warning';
}
